import React from 'react';
import { FiLinkedin } from "react-icons/fi";
import ScrollAnimation from "react-animate-on-scroll";


const MemberBios = ({image,link, title, description,text1,text2,text3}) => {
    return (
        <div className='main-member-bios'>
            <div className="row mx-auto align-items-center row--15 service-wrapper">
                <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={'mt--25 responsive-padding-member text-center'} style={{height:"300px"}}>
                            <div className="icon">
                                <img src={image} alt="Member" width={"200px"} style={{paddingBottom:"10px"}}/>
                            </div>
                            <div className="content">
                                <h4 className="title w-600" style={{margin:"0px"}}><a href={`${link}`} rel="noreferrer" target='_blank' dangerouslySetInnerHTML={{__html: title}}></a></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: description}}></p>
                            </div>
                            <a href={`${link}`} rel="noreferrer" target='_blank'>
                            <div className='icon bios-icon pt-2'>
                                <FiLinkedin/>
                            </div>
                            </a>
                        </div>
                    </ScrollAnimation>
                </div>
                <div className='col-lg-8 col-md-6 col-sm-6 col-12'>
                    <div className="content">
                        <p className="description b1 color-gray" dangerouslySetInnerHTML={{__html: text1}}></p>
                        <p className="description b1 color-gray" dangerouslySetInnerHTML={{__html: text2}}></p>
                        <p className="description b1 color-gray" dangerouslySetInnerHTML={{__html: text3}}></p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default MemberBios;